import { findIndex } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
  display: false,
  type: null,
  data: null,
  size: 'sm',
  connect: -1,
  shown: [],
  next: null
};

export function ModalReducer(state = { modal: [] }, action) {
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  switch (action.type) {

        case 'SET_MODAL':

            protocolSection.scene.modal = {...protocolSection.scene.modal, ...action.payload};

            if(!action.payload.hasOwnProperty('next')){
              protocolSection.scene.modal.next = null;
            }

            if(protocolSection.scene.modal.display){
              if(!protocolSection.scene.modal.shown.some(e => e.type === protocolSection.scene.modal.type)){
                protocolSection.scene.modal.shown.push({
                  type: protocolSection.scene.modal.type,
                  size: protocolSection.scene.modal.size,
                  data: protocolSection.scene.modal.data
                })
              }
            }

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SHOW_MODAL':

            // xAPI statement
            // sendxAPI({
            //   // Type of statement
            //   verb: {
            //     description: "focused",
            //     address: "https://w3id.org/xapi/dod-isd/verbs/focused"
            //   },
            //   // Where the action occured
            //   context: state.type + " modal display",
            //   // Result of the action
            //   result: {
            //     success: true,
            //     response: action.payload
            //   }
            // })
            protocolSection.scene.modal.display = action.payload.display;

            if(protocolSection.scene.modal.display){
              if(!protocolSection.scene.modal.shown.some(e => e.type === protocolSection.scene.modal.type)){
                protocolSection.scene.modal.shown.push({
                  type: protocolSection.scene.modal.type,
                  size: protocolSection.scene.modal.size,
                })
              }
            }

            return { ...state, ...{
              protocolSection: protocolSection
            } }

          case "UNDO":
              //Payload = {lastState}

              if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('modal')) {

                protocolSection.scene.modal = action.payload.lastState.scene.modal
                protocolSection.scene.modal.display = false

                return { ...state, ...{
                  protocolSection: protocolSection
                } }

              } else {
                return state;
              }

        default:
            return state
    }
}
